import { ArrowBack, Group } from '@mui/icons-material';
import { Box, Button, Container, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useAuthContext } from 'src/context/AuthContextProvider';

import { useMonitorContext } from '../MonitorContextProvider';

export function MonitorGuestEnvironmentBanner() {
  const history = useHistory();
  const { auth } = useAuthContext();
  const { guestEnvironmentOwnerId } = useMonitorContext();

  if (!guestEnvironmentOwnerId) {
    return null;
  }

  const guestUserWalletEnvironment =
    auth.user?.guestUserWalletEnvironments?.find(
      (environment) => environment.owner.id === Number(guestEnvironmentOwnerId),
    );

  if (!guestUserWalletEnvironment) {
    return null;
  }

  return (
    <Box
      sx={{
        width: 'calc(100vw - 56px)',
        backgroundColor: '#FF8211',
        position: 'fixed',
        top: 75,
        left: 56,
        right: 0,
        zIndex: 1100,
        '@media (max-width: 1279px)': {
          width: '100vw',
          left: 0,
          top: 75,
        },
        '@media (max-width: 599px)': {
          top: 150,
        },
      }}>
      <Container
        maxWidth="lg"
        sx={{
          display: { xs: 'block', sm: 'flex' },
          alignItems: 'center',
          justifyContent: 'space-between',
          color: 'white',
          gap: 2,
          py: 0.5,
          px: { xs: 2, sm: 1 },
        }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Group sx={{ fontSize: 28 }} />
          <Typography variant="body1">
            Você está visualizando o ambiente de&nbsp;
            <strong style={{ color: 'white' }}>
              {guestUserWalletEnvironment?.owner.name}
            </strong>
          </Typography>
        </Box>
        <Button
          variant="text"
          sx={{ color: 'white', textTransform: 'none', whiteSpace: 'nowrap' }}
          startIcon={<ArrowBack />}
          onClick={() => history.replace('/monitor')}>
          Voltar para o meu ambiente
        </Button>
      </Container>
    </Box>
  );
}
